import { render } from "./MainLayout.vue?vue&type=template&id=1cf84d75"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/candidate-package/MainLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1cf84d75"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1cf84d75', __exports__)) {
    api.reload('1cf84d75', __exports__)
  }
  
  module.hot.accept("./MainLayout.vue?vue&type=template&id=1cf84d75", () => {
    api.rerender('1cf84d75', render)
  })

}


export default __exports__